import React, { useEffect } from "react";
import GlobalStyles from 'styles/GlobalStyles';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "@fontsource/roboto";

import ErrorBoundary from "helpers/ErrorBoundary";

/* Web Pages */
import TourPage from "pages/TourPackage.js";
import GalleryPage from "pages/GalleryPage.js";
import BlogPage from "pages/BlogsPage.js";
import EventPage from "pages/EventPage.js";
import ResortPage from "pages/HotelResortsPage.js";
import KnowPage from "pages/AboutUs.js";
import ServicePage from "pages/ServicePage";
import TermsOfService from "pages/TermsOfService";
import PrivacyPolicy from "pages/PrivacyPolicy";
import WriteReview from "pages/ReviewPage";
import DestinationsPage from "pages/DestinationsPage";
import ViewDestination from "pages/ViewDestination";
import ReadBlog from "pages/ReadBlog";

import ScrollTop from "components/other-cards/ScrollTop";

import LandingPage from "TraviatorLanding.js";
import Page404 from "pages/404Page";
import ErrorPage from "pages/ErrorPage";

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import WriteBlog from "pages/WriteBlog";
import VisaPage from "pages/VisaPage";

// Firebase configuration and initialization
import { app, analytics } from "./firebaseConfig";

const App = () => {

  useEffect(() => {
    const handlePopState = () => {
      window.location.reload(); // Reload the page on back navigation
    };

    const handleRefresh = () => {
      window.scrollTo(0, 0);
      setTimeout(function () {
        window.location.reload();
      }, 2000);
    };
    // Add `popstate` event listener
    window.addEventListener("popstate", handlePopState);
    window.addEventListener("beforeunload", handleRefresh);
    // Cleanup the event listener
    return () => {
      window.removeEventListener("popstate", handlePopState);
      window.removeEventListener("beforeunload", handleRefresh);
    };
  }, []);

  console.reportErrorsAsExceptions = false;

  return (
    <>
      <GlobalStyles />
      <Router>
        <ScrollTop />
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/pg/error" element={<ErrorPage />} />
            <Route path="/pg/tours" element={<TourPage />} />
            <Route path="/pg/visa-checklist" element={<VisaPage />} />
            <Route path="/pg/gallery" element={<GalleryPage />} />
            <Route path="/pg/blogs" element={<BlogPage />} />
            <Route path="/pg/blogs/:blogId/read" element={<ReadBlog />} />
            <Route path="/pg/blogs/write" element={<WriteBlog />} />
            <Route path="/pg/events" element={<EventPage />} />
            <Route path="/pg/resorts" element={<ResortPage />} />
            <Route path="/pg/know-us" element={<KnowPage />} />
            <Route path="/pg/services" element={<ServicePage />} />
            <Route path="/pg/destinations" element={<DestinationsPage />} />
            <Route path="/pg/destinations/explore/:id" element={<ViewDestination />} />
            <Route path="/pg/write-review" element={<WriteReview />} />
            <Route path="/pg/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/pg/terms-conditions" element={<TermsOfService />} />
            <Route path="*" element={<Page404 />} />
          </Routes>
        </ErrorBoundary>
      </Router>
    </>
  );
};

export default App;
